export const ROLES = {
    ADMIN : "admin",
    ORGANIZER : "organizer"
}